import { Injectable } from "@angular/core";
import * as CryptoJS from 'crypto-js';
import { UserAuthentication } from "../interfaces/user-authentication";
import { environment } from 'src/environments/environment';
import { HTTPService } from "./http.service";

@Injectable({
    providedIn: 'root'
  })
  
  export class AdminServices {
   
  user:UserAuthentication = null;

  constructor(private http:HTTPService) { 
      
  }



  encryptSankhyaData(codeCompany:String, valueToEcrypy:string){
    let ob = {
      "expressao": "encryptSankhyaData("+codeCompany+","+ valueToEcrypy+")",
      "novo": true,
      "codecompany": codeCompany,
      "codemktp": 62,
      "codecontract": 0,
      "values":[]
    }
        
      return this.http.post(ob,'FormulaServices/test', true,true,false);
  }

}  